<template>
    <div class='orderBox'>
        <el-row class="orderCenter">
            <el-col class="borde">
                <div >
                    <el-col :span="12" class="bordeLeft">订单详情</el-col>
                </div>
            </el-col>
        </el-row>
        <!-- 步骤条 -->
        <el-row class="step">
          <el-steps :active="stepActiv" align-center>
            <el-step title="换票方申请融资" :description="tickeTime"></el-step>
            <el-step title="系统派给接单方" :description="systemTime"></el-step>
            <el-step title="接单方打款" :description="sideTime"></el-step>
            <el-step title="换票方背书" :description="holderTime"></el-step>
            <el-step title="接单方签收" :description="fundTime"></el-step>
            <el-step title="接单方背书" :description="endorserTime"></el-step>
            <el-step title="换票方签收" :description="changerTime"></el-step>
            <el-step title="交易完成" :description="completionTime"></el-step>

            <!-- <el-step title="融资方申请融资" ></el-step>
            <el-step title="系统派单资金方" ></el-step>
            <el-step title="资金方打款" ></el-step>
            <el-step title="持票方背书" ></el-step>
            <el-step title="资金方签收" ></el-step>
            <el-step title="资金方背书" ></el-step>
            <el-step title="签收" ></el-step>
            <el-step title="交易完成" ></el-step> -->
          </el-steps>
        </el-row>
        <!-- 订单详情 -->
        <el-row>
            <el-row class="statusRow">
              <el-col :span="19" class="status">
                <!-- <div v-if="dataList.status=='100;101'">订单状态：待接单</div>
                <div v-if="dataList.status=='600;620'">订单状态：待背书</div>
                <div v-if="dataList.status=='700;610'">订单状态：待签收</div>
                <div v-if="dataList.status=='220'">订单状态：待签收</div>
                <div v-if="dataList.status==800">订单状态：已完成</div>
                <div v-if="dataList.status==100">订单状态：已关闭</div> -->


                <div v-if="dataList.status==101">订单状态：待换票方确认</div>
                <div v-if="dataList.status==100">订单状态：待后台确认</div>
                <div v-if="dataList.status==102">订单状态：待接单方确认</div>

                <div v-if="dataList.status==200">订单状态：待接单方支付</div>
                <div v-if="dataList.status==600">订单状态：待换票方背书</div>
                <div v-if="dataList.status==610">订单状态：待接单方签收</div>
                <div v-if="dataList.status==620">订单状态：待接单方背书</div>
                <div v-if="dataList.status==700">订单状态：待换票方签收</div>

                <div v-if="dataList.status==800">订单状态：已完成</div>

                <div v-if="dataList.status==810">订单状态：已关闭</div>

              </el-col>
              <!-- <el-col :span='2'>
                  <el-button v-if="dataList.status=='100;101'" type="primary" @click="handleClick()">补充信息</el-button>
              </el-col>
              <el-col :span='2'>
                  <el-button v-if="dataList.status=='100;101'"  @click="handleGets()">指派订单</el-button>
              </el-col> -->
              <el-col :span='2'>
                  <el-button v-if="dataList.status==100" type="primary" @click="handleClick()">补充信息</el-button>
              </el-col>
              <el-col :span='2'>
                  <el-button v-if="dataList.status==100"  @click="handleGets()">指派订单</el-button>
              </el-col>
            </el-row>
          <el-row class="center">
            <el-col :span="12" class="centerLeft">
              <div class="orderMsg">
                <div>
                  <span>订单号：</span>
                  <span>{{dataList.orderId}}</span>
                </div>
                <div>
                  <span>票号：</span>
                  <span>{{dataList.billNum}}</span>
                </div>
                <div>
                  <span>承兑人：</span>
                  <span>{{dataList.acceptingBank}}</span>
                </div>
                <div>
                  <span>票面金额：</span>
                  <span>{{dataList.billAmt}}元</span>
                </div>
                <div>
                  <span>到期日：</span>
                  <span>{{dataList.endDate}}({{dataList.subDays}})</span>
                </div>
                <div>
                  <span>瑕疵情况：</span>
                  <span>{{dataList.billFeature}}</span>
                </div>
                <div>
                  <span>背书手数：</span>
                  <span>{{dataList.bsSS}}手背书</span>
                </div>
                <div class="line"></div>
              <div class="wrapper">
                  <!-- <div class="left">
                      <div>
                        <span>每十万扣款：</span>
                        <span>/</span>
                      </div>
                      <div>
                        <span>年化：</span>
                        <span>/</span>
                      </div>
                      <div>
                        <span>手续费：</span>
                        <span>/</span>
                      </div>
                      <div>
                        <span>实际转让金额：</span>
                        <span>/</span>
                      </div>
                  </div> -->
                  <div class="right">
                      <div class="pic1">
                        <img :src="dataList.billFrontUrl" alt="" class='uzi'>
                        <span class="showbig" @click="handleShowBigOne">查看大图</span>
                      </div>
                      <div class="pic2">
                        <img :src="dataList.billBackUrl" alt="" class='uzi'>
                        <span class="showbig"  @click="handleShowBigTwo">查看大图</span>
                      </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="12" class="centerRight">
              <div class="changeStatus">
                <p class="pone">此次交易票据的意向金</p>
                <p class="ptwo">{{dataList.sellGuarantee}}</p>
                <p class="ptre">我司账户:{{dataList.platformname}}</p>
                <!-- <p class="ptre marss">我司的苏宁账号展示</p> -->
                <p class="pone marss">此次交易票据的保证金</p>
                <p class="ptwo">{{dataList.buypay }}</p>
                <p class="pfiv">（差额{{dataList.difference}}+保证金{{dataList.buyGuarantee}}）</p>
              </div>
            </el-col>
          </el-row>

          <div class="dodos">
              <el-col :span="12" class="dodoLeft">
                  <div class="dodotop orderMsg">
                      <p class="vsas">(需求方）账户信息</p>
                      <div>
                        <span>企业名称：</span>
                        <span>{{dataList.cmpName}}</span>
                      </div>
                      <div>
                        <span>开户行：</span>
                        <span>{{dataList.bankBranch}}</span>
                      </div>
                      <div>
                        <span>银行账号：</span>
                        <span>{{dataList.acctCode}}</span>
                      </div>
                  </div>
                  <div class="dodobot orderMsg">
                      <p class="vsas">(资金方）账户信息</p>
                      <div>
                        <span>企业名称：</span>
                        <span>{{dataList.channelAcctName}}</span>
                      </div>
                      <div>
                        <span>开户行：</span>
                        <span>{{dataList.channelBankBranch }}</span>
                      </div>
                      <div>
                        <span>银行账号：</span>
                        <span>{{dataList.channelAcctCode}}</span>
                      </div>
                  </div>
              </el-col>
              <el-col :span="12" class="dodoRight">
                <p class="mrsp">相关协议</p>
                <div class="odd mars" @click="handleShowOne()">
                          《票据应收款转让服务合同》
                </div>
              </el-col>
          </div>

          <el-row class="agreement">
            <el-col :span="24">
              <el-col :span="24" class="vsas">
                  换票需求
              </el-col>
              <el-col :span="24" class="titbot">
                  <p>{{dataList.demand}}</p>
              </el-col>
            </el-col>
          </el-row>
          <el-col :span='24' class="tablesbox">
              <!-- 请求数据模拟数据，testData是用来模拟数据的 -->
              <el-table
                ref="multipleTable"
                :data="arrlist"
                tooltip-effect="dark"
                style="width: 100%"
              >
                  <el-table-column
                      prop="billNum"
                      width="280"
                      label="票据号码"
                  >
                  </el-table-column>
                  <el-table-column
                      prop="billAmt"
                      label="票面金额(万元)"
                  >
                  </el-table-column>
                  <el-table-column
                      prop="acceptingBank"
                      label="承兑人"
                  >
                  </el-table-column>
                  <el-table-column
                      prop="endDate"
                      label="到期日"
                      show-overflow-tooltip>
                  </el-table-column>
                        <!-- 剩余背书时间选项，只有在待背书界面时才会被显示 -->
                  <el-table-column
                    prop="zip"
                    label="票面"
                    fixed="right"
                  >
                      <template slot-scope="scope" >
                          <!-- <el-button type="text" class="reciteBtn2"  @click.stop="handleCcClick(scope.row)">查看</el-button> -->
                          <el-image
                            style="width: 100px; height: 100px"
                            :src="scope.row.billFrontUrl"
                            :preview-src-list="scope.row.imglist">
                          </el-image>
                      </template>
                  </el-table-column>
              </el-table>
          </el-col>
        </el-row>

        <el-dialog
                title="请选择派单用户"
                :visible.sync="dialogV"
                :before-close="handleClose"
                width="380px"
                >
                    <div class="mnv">
                        <el-col class="dodod" :span="6">手机号:</el-col><el-col :span="18"><el-input v-model="inputVal" placeholder="请输入手机号" @blur="handleSearCom"></el-input></el-col>
                    </div>
                    <div class="mnv">
                        <el-col class="dodod" :span="6">公司名称:</el-col><el-col :span="18"><el-input v-model="comsVal" placeholder="公司名称" ></el-input></el-col>
                    </div>
                    <div class="bud">
                        <el-button type="primary" class="butg"  @click="submitForm()">确认</el-button>
                    </div>
        </el-dialog>

        <el-dialog
                title="补充订单信息"
                :visible.sync="dialogMesg"
                :before-close="handleClose"
                width="580px"
                >
                    <div class="mnv qwe">
                        <el-col class="dodovv" :span="7">直客意向金:</el-col><el-col :span="16"><el-input v-model="moneyone" :maxlength="11" placeholder="请输入直客意向金"  @blur="handleSearCom"></el-input></el-col>
                    </div>
                    <div class="mnv zxc">
                        <el-col class="dodovv" :span="7">中介保证金&差额(元):</el-col><el-col :span="8"><el-input v-model="moneytwo" placeholder="中介保证金" ></el-input></el-col><el-col :span="8"><el-input v-model="moneytre" placeholder="差额" ></el-input></el-col>
                    </div>
                    <div class="mnv zxc">
                        <el-col class="dodovv" :span="7">票据类型:</el-col><el-col :span="8">
                            <el-select v-model="Selvalue" placeholder="请选择">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                            </el-col>
                    </div>
                    <div class="mnv zxc">
                        <el-col class="dodovv" :span="7">换票需求:</el-col><el-col :span="16"><el-input v-model="textVal" placeholder="换票需求"  type="textarea" :rows="2"></el-input></el-col>
                    </div>
                    <div class="bud">
                        <el-button type="primary" class="butg"  @click="changeClick()">确认</el-button>
                    </div>
        </el-dialog>

        <el-dialog
            title="票据应收款转让服务协议"
            :visible.sync="dialogOne"
            width="950px"
        >
            <div class="treeCon">
                <embed
                    :src="oneSrc"
                    type="application/pdf"
                    class="emb"
                />
            </div>
        </el-dialog>
        <el-dialog
            :visible.sync="oneModal"
            width="30%"
            center>
            <img :src="dataList.billFrontUrl" alt="" class='uzi'>
        </el-dialog>

        <el-dialog
            :visible.sync="twoModal"
            width="30%"
            center>
            <img :src="dataList.billBackUrl" alt="" class='uzi'>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data(){
        return{
            completionTime:'',
            changerTime:'',
            endorserTime:'',
            fundTime:'',
            holderTime:'',
            sideTime:'',
            systemTime:'',
            tickeTime:'',
            stepActiv:1,
            PriceChange:false,
            oneSrc:'',
            twoSrc:'',
            dialogOne:false,
            dialogTwo:false,
            Receive:false,
            receiveText: '受让方将在约定时间内完成签收，请耐心等候',
            dataList:{},
            oneModal:false,
            twoModal:false,
            inputVal:'',
            yearRate:'',
            yearPrice:'',
            yzmVal:'',
            disabled:false,
            btntxt:'获取验证码',
            showCk:false,
            testData:[],
            dialogV:false,
            inputVal:'',
            comsVal:'',
            arrlist:[],
            msgid:'',
            custNo:'',
            dialogMesg:false,
            Selvalue:'',
            textVal:'',
            moneytre:'',
            moneytwo:'',
            moneyone:'',
            options: [{
                value: '国股',
                label: '国股'
                }, {
                value: '大商',
                label: '大商'
                }, {
                value: '城商',
                label: '城商'
                }, {
                value: '三农',
                label: '三农'
                }, {
                value: '村镇',
                label: '村镇'
            }, {
                value: '外贸',
                label: '外贸'
            }, {
                value: '财票',
                label: '财票'
            }],
        }
    },
    mounted(){
        this.handleAjax()
    },
    methods:{
      handleAjax(){
            let bizContent={}
            bizContent.orderId=this.$route.query.oId
            this.ajax.post('/jyOder/jyPiaoDetail',{bizContent})
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.stepActiv=result.data.data.statusSell
                                this.dataList=result.data.data
                                if(this.dataList.transferlist==undefined){
                                    
                                }else{
                                    let add = this.dataList.transferlist
                                    add.map((it,index)=>{
                                      let arr=[]
                                      arr.push(it.billFrontUrl)
                                      arr.push(it.billBackUrl)
                                      it.imglist=arr
                                    })
                                    this.arrlist=add
                                }
                                
                                
                                let arr = result.data.data
                                this.moneyone=arr.sellGuarantee
                                this.moneytwo=arr.buyGuarantee
                                this.moneytre=arr.difference
                                this.Selvalue=arr.accepttype
                                this.textVal=arr.demand


                                //步骤条接口
                                
                                this.ajax.post('/jyOder/orderStageList',{bizContent:{orderId:result.data.data.orderId}})
                                .then(
                                    result=>{
                                      if(result.data.status=='0000'){
                                          let dataListed=result.data.data
                                          if(dataListed==null){
                                                console.log(222)
                                          }else{
                                              dataListed.map((item)=>{
                                               
                                                  if(item.stageType===1){
                                                    this.tickeTime=item.stageTime
                                                  }
                                                  if(item.stageType===2){
                                                    this.systemTime=item.stageTime
                                                  }
                                                  if(item.stageType===3){
                                                    this.sideTime=item.stageTime
                                                  }
                                                  if(item.stageType===4){
                                                    this.holderTime=item.stageTime
                                                  }
                                                  if(item.stageType===5){
                                                    this.fundTime=item.stageTime
                                                  }
                                                  if(item.stageType===6){
                                                    this.endorserTime=item.stageTime
                                                  }
                                                  if(item.stageType===7){
                                                    this.changerTime=item.stageTime
                                                    if(this.statusrt==800){
                                                        this.completionTime=item.stageTime
                                                    }
                                                  }
                                              })
                                          }
                                          
                                          
                                          
                                      }else{
                                          this.$message({
                                                  type: 'warning',
                                                  duration:5000,
                                                  message: result.message,
                                                  center: true,
                                                  offset:300
                                          });
                                      }
                                    }
                                )
                                if(result.data.data.status==800){
                                      if(result.data.data.orderAgreementList==null){
                                        this.ajax.post('/merchant/getmerchant',{bizContent:{merchantCode:"dianpiaobao"}})
                                        .then(
                                            result=>{
                                              if(result.data.status=='0000'){
                                                  this.oneSrc=result.data.data.agreementExtendOne
                                                  // this.dialogOne=true
                                              }else{
                                                  this.$message({
                                                              type: 'warning',
                                                              duration:5000,
                                                              message: result.data.message,
                                                              center: true,
                                                              offset:300
                                                      });
                                                  }
                                            }
                                        )
                                    }else{
                                        this.oneSrc='https://img.dianpiaobao.com/'+result.data.data.orderAgreementList[0].agreementUrl
                                    }
                                }else{
                                    //协议
                                    this.ajax.post('/merchant/getmerchant',{bizContent:{merchantCode:"dianpiaobao"}})
                                    .then(
                                        result=>{
                                          if(result.data.status=='0000'){
                                              this.oneSrc=result.data.data.agreementExtendOne
                                              // this.showCk=true
                                          }else{
                                              this.$message({
                                                          type: 'warning',
                                                          duration:5000,
                                                          message: result.data.message,
                                                          center: true,
                                                          offset:300
                                                  });
                                              }
                                        }
                                    )

                                }
                                
                                if(result.data.data.status==620){
                                      this.stepActiv=5
                                }else if(result.data.data.status==600){
                                    this.stepActiv=3
                                }else if(result.data.data.status==800||result.data.data.status==810){
                                    this.stepActiv=8
                                }else if(result.data.data.status==102){
                                    this.stepActiv=1
                                }else if(result.data.data.status==200){
                                    this.stepActiv=2
                                }else if(result.data.data.status==700){
                                    this.stepActiv=6
                                }else if(result.data.data.status==610){
                                    this.stepActiv=4
                                    
                                }else if(result.data.data.status==100 || result.data.data.status==101 || result.data.data.status==102){
                                    this.stepActiv=1
                                }



                            }else{
                                this.$message({
                                        type: 'warning',
                                        duration:5000,
                                        message: result.data.message,
                                        center: true,
                                        offset:300
                                });
                            }
                        }
            )
    },
    handleMoney(){
            this.$router.push({
                name:'moneyTrue'
            })
        },
    handleCcClick(val){
        let list=[]
        list.push(val.billFrontUrl)
        list.push(val.billBackUrl)
    },
    handleShowOne(val){
        this.dialogOne=!this.dialogOne
    },
        handleShowTwo(val){
            if(val==''){
                this.$message('该授权书签约后可查看')
                return false;
            }
            let url='https://img.borntrust.com/'+val
            this.twoSrc=url
            this.dialogTwo=!this.dialogTwo
        },
        handleCxClick(val){
            this.$confirm('您确定要撤单?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.post('/jyorder/orderUpOrDown',{bizContent:{orderId:this.dataList.orderId,uid:this.$store.state.userId,statusType:'1'}})
                .then(
                    result=>{
                        if(result.status=='0000'){
                            this.$message('撤单成功！');
                            this.$message({
                                        type: 'success',
                                        duration:5000,
                                        message: '撤单成功！',
                                        center: true,
                                        offset:300
                                });
                            this.handleAjax()
                        }else{
                            this.$message({
                                        type: 'warning',
                                        duration:5000,
                                        message: result.data.message,
                                        center: true,
                                        offset:300
                                });
                            }
                        }
                )
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消撤单'
                });
            });
        },
        handleGets(){
            this.dialogV=!this.dialogV
        },
        handleClick(val){
            this.dialogMesg=!this.dialogMesg
        },
        handleSearCom(){
            this.ajax.post('/jyOder/getcompanybyphone',{bizContent:{phone:this.inputVal}})
                .then(
                    result=>{
                        if(result.data.status=='0000'){
                            this.comsVal=result.data.data.companyName
                            this.custNo=result.data.data.custNo
                        }else{
                            }
                        }
                )
        },
        submitForm(){
            this.ajax.post('/jyOder/dispatchorder',{bizContent:{oderId:this.$route.query.oId,uid:this.$store.state.userId,phone:this.inputVal,name:this.comsVal,custNo:this.custNo}})
                .then(
                    result=>{
                        if(result.data.status=='0000'){
                            this.dialogV=false
                            this.handleAjax()
                            this.$message({
                                type: 'success',
                                duration:5000,
                                message: '指派成功！',
                                center: true,
                                offset:300
                            });
                        }else{
                            }
                        }
                )
        },
        changeClick(){
            let bizContent={}
            bizContent.orderId=this.$route.query.oId
            bizContent.sellGuarantee=this.moneyone
            bizContent.buyGuarantee=this.moneytwo
            bizContent.difference=this.moneytre
            bizContent.demand=this.textVal
            bizContent.accepttype=this.Selvalue
            this.ajax.post('/jyOder/jyPiaoDetail',{bizContent})
                .then(
                    result=>{
                        if(result.data.status=='0000'){
                            this.dialogMesg=false
                            this.$message({
                                type: 'success',
                                duration:5000,
                                message: '信息补充成功！',
                                center: true,
                                offset:300
                            });
                        }else{
                            }
                        }
                )
        },
        handleShowBigOne(){
            this.oneModal=!this.oneModal
        },
        handleShowBigTwo(){
            this.twoModal=!this.twoModal
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
            .then(_ => {
                done();
                this.handleAjax()
            })
            .catch(_ => {});
        },
        handleChangePrice(val){
            this.PriceChange=true
        },
        handleInputs(){
            let bizContent={}
            bizContent.mswkx=this.inputVal
            bizContent.rate=''
            bizContent.billAmt=this.dataList.getMony
            bizContent.endDate=this.dataList.endDate
                this.ajax.post('/jyorder/getZKLORRATE',{bizContent})
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.yearRate=result.data.data.rate
                                this.yearPrice=result.data.data.getMony+'元'

                            }else{
                                // this.$message(result.data.message);
                                this.$message({
                                        type: 'warning',
                                        duration:5000,
                                        message: result.data.message,
                                        center: true,
                                        offset:300
                                });
                            }
                        }
                )
        },
        handleGetYZM(){
            let bizContent={}
            bizContent.mobile=this.$store.state.userInfor
            bizContent.type="pricepsd"
            bizContent.mergeKey=''
                this.ajax.post(this.versa.imgUrl+'/sms/sendSms',{bizContent})
                        .then(
                            result=>{
                                if(result.data.status=='0000'){
                                    this.$message({
                                        type: 'success',
                                        duration:5000,
                                        message: '验证码已发送至您的手机上',
                                        center: true,
                                        offset:300
                                    });
                                    this.time=60;
                                    this.disabled=true
                                    this.timer();
                                }else{
                                    // this.$message(result.data.message);
                                    this.$message({
                                        type: 'warning',
                                        duration:5000,
                                        message: result.data.message,
                                        center: true,
                                        offset:300
                                    });
                                }
                            }
                )
        },
        timer:function () {
            if (this.time > 0) {
                this.time--;
                this.btntxt=this.time+"s后重新获取";
                setTimeout(this.timer, 1000);
                this.disabled=true;
            } else{
                this.time=0;
                this.btntxt="获取验证码";
                this.disabled=false;
            }
        },
        handleTruePrice(){
                let bizContent={}
                bizContent.uid=this.$store.state.userId
                bizContent.orderId=this.dataList.orderId
                bizContent.tenThousandDiscount=this.inputVal
                bizContent.channelYearRate=this.yearRate
                bizContent.smsCode=this.yzmVal
                this.ajax.post('/jyorder/jyOrderSellChangePrice',{bizContent})
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.$message({
                                        type: 'success',
                                        duration:5000,
                                        message: '改价成功！',
                                        center: true,
                                        offset:300
                                });
                                this.handleAjax()
                            }else{
                                // this.$message(result.data.message);
                                this.$message({
                                        type: 'warning',
                                        duration:5000,
                                        message: result.data.message,
                                        center: true,
                                        offset:300
                                    });
                            }
                        }
                )
        },
        handleSetCard(){
            this.handleAjax()
            this.Receive = false
        },
        handleGetBook(val){
            this.Recited=true
        },
        handleCopy(val){
            const input = document.createElement('input')
            document.body.appendChild(input)
            input.setAttribute('value',val)
            input.select()
            if (document.execCommand('copy')) {
                document.execCommand('copy')
            }
            document.body.removeChild(input)
            this.$message("复制成功")
        }
    },
}
</script>

<style  scoped>
.orderBox{
    margin-left: 20px;
    background: rgba(255,255,255,1);
    width: 1300px;
}

.orderCenter{
    margin-top: 0px;
}

.borde{
    height: 60px;
    line-height: 60px;
    /* width: 100%; */
    border: 1px solid rgba(227,228,229,1);
    background:rgba(252,252,252,1);
    margin-bottom: 20px;
    border-radius:4px 4px 0px 0px;
}

.bordeLeft{
    font-weight: 400;
    padding-left: 20px;
    font-size: 18px;
    color: rgba(51,51,51,1);
    width: 480px;
    height: 25px;
    line-height: 25px;
    font-family:PingFangSC-Regular,PingFang SC;
    margin-top: 14px;
    /* background:rgba(252,252,252,1); */
}

/* .el-col {
    border-radius: 4px;
  } */

.wrapper{
  display: flex;
}
.left{
  width: 220px;
  text-align:left;
  box-shadow:0 0 black;
}
.right{
  display: flex;
  height: 96px!important;
  margin-left: 10px;
  box-shadow:0 0 black;
}
.pic1,.pic2{
  width:135px;
  height:96px!important;
  margin-left: 20px;
  text-align: center;
}
.showbig{
  margin-bottom: 5px;
  margin-top: 10px;
  color: #007AFF;
  display: inline-block;
}
.showbig:hover{
  cursor: pointer;
}
.odd{
    color: cornflowerblue;
    text-decoration: underline;
}
.odd:hover{
    cursor: pointer;
    color: black;
}

.button{
    background: #3E5F9CFF;
    margin-top: 20px;
}

.step{
  padding-top: 26px;
  background:rgba(255,255,255,1);
  height: 104px;
  margin-bottom: 40px;
}

.statusRow{
  width: 1250px;
  height:55px;
  margin-left: 20px;
  line-height: 55px;
  background:rgba(252,252,252,1);
  border-radius:4px 4px 0px 0px;
  border:1px solid rgba(227,228,229,1);
}

.status{
  height:55px;
  line-height: 55px;
  padding-left: 18px;
}

.center{
  /* background: cadetblue; */
  width:1250px ;
  margin-left: 20px;
  height: 420px;
  border:1px solid rgba(239,239,239,1);
}

.centerLeft{
  width: 840px;
  height:420px;
}
.orderMsg{
  padding-top: 9px;
  padding-left: 17px;
}
.centerRight{
  background: rgba(252,252,252,1);
  width: 408px;
  height:420px;
  border-left:1px solid rgba(239,239,239,1);
}
.dodos{
  width: 1248px;
  height: 320px;
  margin-left: 20px;
  border: 1px solid rgba(239,239,239,1);
}
.dodoLeft{
  width: 840px;
  height:320px;
}
.dodoRight{
  background: rgba(252,252,252,1);
  width: 408px;
  height:320px;
  border-left:1px solid rgba(239,239,239,1);
  border-top: 1px solid  rgba(239,239,239,1);
  text-align: center;
}
.changeStatus{
  padding: 20px 30px;
  text-align: center;
}
.pone{
  font-size: 14px;
  color: #333;
  margin-bottom: 20px;
}
.ptwo{
  font-size: 22px;
  color: #198AF1;
  margin-bottom: 10px;
}
.ptre{
  font-size: 14px;
  color: #666;
}
.pfiv{
  font-size: 14px;
  color: #198AF1;
}
.marss{
  margin-top: 20px;
}
.orderMsg>>>div{
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(85,85,85,1);
  line-height:20px;
  margin-bottom: 14px;
}
.orderMsg>>>div span:first-child{
  display: inline-block;
  width: 120px;
  /* color: red; */
}
.line{
  width:820px;
  height:2px!important;
  background: #E8E7E7;
  margin-bottom: 16px!important;
}

.changePrice{
  padding-top: 160px;
  text-align: center;
  /* border: none; */
}

.changePrice>>>div{
  margin: 20px 0;
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:20px;
}

.firstButton{
  border-radius:4px;
  border:1px solid rgba(58,91,160,1);
  box-sizing: border-box;
  color:#3E5F9C ;
}

.agreement{
  width:1250px;
  height:auto;
  border:1px solid rgba(239,239,239,1);
  margin-bottom: 10px;
  margin-left: 19px;
  padding: 24px 0;
  padding-left: 18px;
}
.titTop{
  height:17px;
  font-size:12px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(85,85,85,1);
  line-height:17px;
  margin-bottom: 20px;
}

.waiting{
  padding-top: 196px;
  text-align: center;
}

.waitingText{
  margin-bottom: 42px;
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:20px;
}

.waiting>>>.el-button{
  height:35px;
  background:rgba(62,95,156,1);
  border-radius:4px;
}

.success{
  padding-top: 144px;
  text-align: center;
}
.iconWrap{
  font-size: 37px;
  color: #3E5F9C;
}

.successText{
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:20px;
  margin-top: 33px;
  margin-bottom: 20px;
}

.recite{
  padding-top: 46px;
  text-align: center;
}

.reciteAmount{
  height:28px;
  font-size:20px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(255,93,93,1);
  line-height:28px;
}

.reciteText{
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(51,51,51,1);
  line-height:20px;
  margin-top: 8px;
  margin-bottom: 4px;
}

.reciteTime{
  height:17px;
  font-size:12px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(102,102,102,1);
  line-height:17px;
  margin-bottom: 33px;
}

.resignAccount{
  height:22px;
  font-size:16px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(85,85,85,1);
  line-height:22px;
  margin-bottom: 21px;
}

.bankText{
  margin-bottom: 12px;
  text-align: left;
  padding-left:40px;
}
.first{
  width:84px;
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(85,85,85,1);
  line-height:20px;
}

.second{
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(85,85,85,1);
  line-height:20px;
}

.third{
  height:17px;
  font-size:12px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(0,122,255,1);
  line-height:17px;
}

.notice{
  text-align: center;
  height:17px;
  font-size:12px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(255,93,93,1);
  line-height:17px;
  margin-bottom: 20px;
}

.howRecite{
  border: none;
  background: none;
  color: #007AFF;
  text-decoration: underline;
}

.changePrice>>>.moreWrap{
  color: #D8D8D8;
  font-size: 30px;
}
.jkl{
  height: 80px;
  width: 100px;
}
.uzi{
  height: 100%;
  width: 100%;
}
.Price{
  color:rgba(51,51,51,1);
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  line-height:30px;
  font-weight:400;
  margin-bottom: 20px;
  height: 160px;
  text-align: center;
}
.chaprice{
  font-size: 16px;
  margin-bottom: 7px;
  color: #3E5F9CFF;
}
.zxcv{
  text-align: right;
  padding-right: 50px;
}
.poiu{
  text-align: left;
}
.poiu>>>.el-input__inner{
  height: 30px;
}
.loPhone{
  /* margin: auto; */
  text-align: left;
  padding-left: 89px;
  height: 60px;
}

.loPhoneText{
  padding-top: 9px;
  width:70px;
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(113,113,113,1);
  line-height:20px;
  margin-right: 12px;
}
.inmnb{
  width: 80px;
}
.loPhoneInput{
  width:200px;
  height:34px;
}
.fko{
  text-align: center;
}
.subsd{
  height: 35px;
  width: 106px;
  background: #3E5F9CFF;
  color: #fff;
  margin: auto;
}
.buttons{
  border: none;
  background: #fff;
  color: #3E5F9CFF;
}
.textWrap{
  text-align: center;
}
.fuzhi{
  color: #007AFFFF;
  margin-left: 3px;
}
.fuzhi:hover{
  cursor: pointer;
}
.step>>>.el-step__title.is-process{
  font-weight: 500!important;
}
.step>>>.el-step__head.is-process{
    color: #666!important;
    border-color: #666!important;
}
.treeCon{
    margin-top: 20px;
    height: 626px;
    width: 880px;
    margin-bottom: 10px;
    /* background: #F4F6F8FF; */
}
.emb{
    height: 100%;
    width: 100%;
    margin: auto;
}
.mrsp{
  font-size: 16px;
  font-weight: 600;
  margin-top: 40px;
}
.mars{
  margin-top: 40px;
}
.dodotop{
  height: 159px;
  width: 100%;
  border-bottom: 1px solid #EFEFEF;
}
.dodobot{
  height: 160px;
  width: 100%;
}
.vsas{
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
}
.titbot{
  color: #555;
  font-size: 12px;
}
.tablesbox{
  padding: 0 20px;
}
.tablesbox>>>.cell{
  text-align: center;
}
.mnv{
    overflow: hidden;
    margin-bottom: 20px;
}
.bud{
    text-align: center;
    margin-top: 20px;
}
.butg{
    background: #3E5F9CFF;
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/page/orderexception/exchangeinfo.vue